{
  "newProject": "Neues Projekt",
  "interestPayment": "Zinszahlung auf",
  "dividendPayment": "Dividendenzahlung",
  "simulated": "Simuliert",
  "purchase": "Kauf",
  "sale": "Verkauf",
  "baseCurrency": "Basiswährung für dieses Projekt",
  "progressIndicator": "Fortschrittsindikator",
  "roi": "ROI",
  "roiSliderDate": "ROI jetzt",
  "roiNextGoal": "ROI am Ziel",
  "duration": "Dauer",
  "goal": "Ziel",
  "noInvestment": "Keine Daten",
  "visible": "Außerhalb dieses Projekts sichtbar?",
  "planned": "Geplannt",
  "actual": "Realisiert",
  "yes": "ja",
  "noDraftMode": "nein",
  "delete": "Projekt löschen",
  "addGoal": "Neues Ziel",
  "addGoalDescription": "Lege ein Ziel für dieses Projekt fest.",
  "deleteGoal": "Ziel löschen",
  "name": "Überschrift",
  "transactions": "Transaktionen",
  "assets": {
    "label": "Projektmittel",
    "tooltip": "Hier erscheinen die in dem Projekt verwendete Bankkonten und Assets"
  },
  "add": "Neue Transaktion",
  "addQuote": "Neuer Zukunftspreis",
  "addQuoteDescription": "Lege den zukünftigen Wert eines Assets fest.",
  "addQuoteButtonDisabled": "Füge mindestens ein Asset zu diesem Projekt hinzu, um einen zukünftigen Wert hinzufügen können.",
  "addQuoteButtonEnabled": "Füge einen zukünftigen Wert zu diesem Projekt hinzu.",
  "inflow": {
    "labelTop": "Einzahlung",
    "labelBottom": "Geld erhalten"
  },
  "outflow": {
    "labelTop": "Auszahlung",
    "labelBottom": "Geld ausgeben"
  },
  "transfer": {
    "labelTop": "Transfer",
    "labelBottom": "zwischen Konten"
  },
  "buy": {
    "labelTop": "Kaufen",
    "labelBottom": "eine Anlage"
  },
  "sell": {
    "labelTop": "Verkaufen",
    "labelBottom": "eine Anlage"
  },
  "newAccount": {
    "label": "Neu",
    "description": "New account"
  },
  "applyTemplate": "Musterprojekt anwenden",
  "removeTemplate": "Musterprojekt entfernen",
  "addTransaction": "Transaktion hinzufügen",
  "growthRates": "Wachstumsraten",
  "growthRatesDescription": "Definiere Wachstumraten für Assets in diesem Projekt. Sie gelten nur für dieses Projekt.",
  "growthRatesNonIsolated": "Diese Wachstumraten gelten für alle Assets, auch außerhalb dieses Projektes. Um Wachstumraten nur für ein Projekt festzulegen, schalte den Isolationsmodus ein.",
  "transactionTypes": "Transaktionstypen",
  "transactionDetails": "Transaktionsdetails",
  "date": "Datum",
  "transactionDate": {
    "label": "Transaktionsdatum",
    "tooltip": "Immer auf den 1. Tag des aktuellen Monats gerundet. Passen Sie die Reihenfolge der Transaktionen innerhalb eines Monats durch Ziehen der Transaktionen in der richtigen Reihenfolge in der Projektdetails Ansicht an.",
    "error": "Datum muss ein zukünftiges Datum sein. Verwenden Sie die Kontodetails Ansicht, um eine vergangene Transaktion hinzuzufügen."
  },
  "recurringTransaction": {
    "label": "Sollte diese Transaktion regelmäßig wiederholt werden?"
  },
  "indexed": {
    "label": "Soll der Betrag jedes Jahr steigen?",
    "byInflation": "um Inflationsrate erhöhen (Link)",
    "increaseBy": "erhöhen um"
  },
  "repeating": {
    "label": "Wiederholungsmuster",
    "every": "Wiederhole alle",
    "month": "Monate",
    "year": "Jahre",
    "endBy": "Wiederholung endet:",
    "never": "nie",
    "after": "nach",
    "afterError": "Maximale Anzahl der Perioden ist 999.",
    "occurrences": "Vorkommnissen",
    "on": "am"
  },
  "synchronising": "Synchronisiere...",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "deleteQuote": "Diesen Zukunftspreis löschen",
  "amount": {
    "label": "Betrag",
    "inflowsCanOnlyBePositive": "Eingänge können nur positiv sein. Verwenden Sie Auszahlungen für negative Transaktionen.",
    "outflowsCanOnlyBeNegative": "Auszahlungen können nur negativ sein. Verwenden Sie Einzahlungen für positive Transaktionen.",
    "transfersCanOnlyBePositive": "Transfers sollten immer positiv sein. Um einen Geldfluss in die entgegengesetzte Richtung zu definieren, tauschen Sie die To- und From-Konten aus."
  },
  "exchangeRate": {
    "label": "Währungskurs",
    "mustBeGreaterThanZero": "Währungskurs muss größer als 0 sein."
  },
  "switchToAmount": "Betrag eingeben",
  "switchToFxRate": "Währungskurs eingeben",
  "baseCurrencyAmount": {
    "label": "Betrag (Basiswährung)"
  },
  "currency": "Währung",
  "account": {
    "label": "Die Transaktion wird von diesem Konto abgezogen"
  },
  "accountTo": {
    "label": "Die Transaktion wird auf diesem Konto erscheinen",
    "error": "Für dieses Konto ist kein verbundenes Anlagekonto definiert."
  },
  "transactionDescription": {
    "label": "Transaktionsbeschreibung wird sein",
    "placeholder": "Gehalt",
    "required": "Bitte geben Sie eine Beschreibung ein",
    "length": "Beschreibung muss mindestens 2 Zeichen lang sein"
  },
  "assetAccount": {
    "label": "Neue Anlage erscheint auf diesem Konto",
    "error": "Verbundenes Anlagekonto für dieses Konto ist nicht definiert."
  },
  "assetContributionLabel": {
    "label": "Neuer Beitrag auf diesem Konto",
    "error": "Verbundenes Anlagekonto für dieses Konto ist nicht definiert."
  },
  "designatedDepositConnectedAccountIndex": {
    "label": "Bankkonto für diese Transaktion ",
    "error": "Fehler."
  },
  "assetName": {
    "tooltip": "Dies ist nur eine Platzhalterinformation, die für Simulationen verwendet wird.",
    "label": "Anlagenname",
    "orISIN": "oder ISIN / WKN-Code",
    "placeholder": "Tesla Aktien"
  },
  "assetSymbol": {
    "tooltip": "Wähle ein vorhandenes Wertpapier aus der Liste oder erstelle ein neues. Du kannst einen Platzhalternamen verwenden, da dieser nur für Simulationen verwendet wird.",
    "label": "Wertpapier / ISIN / WKN",
    "placeholder": "DE0000A1B2C3"
  },
  "assetMetal": {
    "label": "Metal",
    "error": "Bitte wähle das Metall aus."
  },
  "assetWeight": {
    "label": "Gewicht (g)",
    "error": "Bitte trage das Gewicht in Gramm ein."
  },
  "assetPurity": {
    "label": "Reinheit (‰)",
    "error": "Bitte trage die Reinheit in Promille (z.B. 999 oder 965) ein."
  },
  "assetAdditionalValue": {
    "label": "Zusatzwert (%)",
    "tooltip": "Zusätzlicher Wert in Prozent, der über den reinen Metallwert hinausgeht (z.B. dank der artistischer oder historischer Bedeutung). Wir erhöhen den Wert des Metalls um diesen Prozentsatz."
  },
  "assetAmount": {
    "label": "Wie viele Anlagen sollen",
    "buy": "gekauft",
    "sell": "verkauft"
  },
  "depositAmount": {
    "label": "Betrag"
  },
  "deposit": "Tagesgeld",
  "assetUnitPrice": {
    "label": "Preis pro Stück",
    "error": "Der Anlageeinheitpreis muss größer als 0 sein."
  },
  "assetContribution": {
    "label": "Beitrag",
    "error": "Beitrag muss größer als 0 sein."
  },
  "assetUnitPriceBaseCurrency": {
    "label": "In Basiswährung",
    "error": "Der Anlageeinheitpreis muss größer als 0 sein."
  },
  "quote": {
    "label": "Preis"
  },
  "quoteBaseCurrency": {
    "label": "In Basiswährung",
    "error": "Der Anlageeinheitpreis muss größer als 0 sein."
  },
  "todaysPrice": "Current price of {{displayName}} is",
  "selectAnOption": "Wähle eine Option",
  "createNewAccount": "Neues Konto erstellen",
  "errorNotAllFields": "Bitte fülle alle Felder aus.",
  "templateInitialisationError": "Fehler: diese Vorlage ist fehlerhaft.",
  "quoteAlreadyExists": "Es existiert bereits einen Zukunftspreis für dieses Asset und Preis. Sie wird durch diesen Preis ersetzt.",
  "quoteProjectWillBeChanged": "Dieser Zukunftspreis wird diesem Projekt hinzugefügt und später zusammen mit ihm gelöscht.",
  "isolatedWarning": "Die Transaktionen und Zukunftspreise sind außerhalb dieses Projekt nicht sichtbar.",
  "collisions": "Welche Zukunftspreise möchtest du behalten?",
  "collisionsDescription": "Du wechselst ein isoliertes Projekt zu einem globalen Projekt. Dieses Projekt hat Zukunftspreise, die bereits in anderen Projekten definiert sind. Du kannst entweder die Werte von diesem Projekt behalten, oder die Werte von den anderen Projekten behalten.",
  "asset": "Vermögenswert",
  "thisProjectQuote": "Dieses Projekt",
  "globalQuote": "Andere Projekte",
  "allCollisionsMustBeResolved": "Bitte wähle eine Option in jeder Zeile aus.",
  "recurring": "Wiederholende Transaktionen",
  "simulatedDividends": "Simulierte Dividenden",
  "simulatedInterest": "Simulierte Zinsen",
  "simulatedQuotes": "Zukunftspreise",
  "applyTemplateDescription": "Wende einen Satz von Transaktionen und zukünftigen Werten auf dein Projekt an. Du kannst sie dann nach Belieben bearbeiten. Wenn du damit nicht zufrieden bist, kannst du die gesamte Vorlage mit einem Klick entfernen.",
  "templates": {
    "select": "Wählen",
    "investToRent": {
      "name": "Vermietung einer Immobilie mit Darlehen",
      "description": "Kauf einer Immobilie zum Vermieten mit Hilfe eines Hypothekdarlehen. Die Mieteinnahmen werden verwendet, um das Darlehen zurückzuzahlen.",
      "role1": "Eigenanteil",
      "transaction1": "Erste erhaltene Überweisung.",
      "transaction2": "Zweite erhaltene Überweisung."
    }
  }
}
